import { SHIFT_MAX_HOURLY_WAGE } from '@src/helpers/shiftHelpers'
import { FormikProps } from 'formik'
import { IScheduleSectionFormValues } from './schedule-section.types'

/**
 * This function is used to get the pay rate error for a given day.
 * It checks if the pay value is greater than the BND set maximum,
 * or if the value is less than the min wage for the selected property
 */
export const getPayRateError = (
  formik: FormikProps<IScheduleSectionFormValues>,
  payValue: number,
) => {
  const {
    values: { min_wage },
  } = formik

  // Check for validation errors based on the actual validation rules
  const maxError =
    payValue > SHIFT_MAX_HOURLY_WAGE
      ? `Pay Rate cannot be greater than $${SHIFT_MAX_HOURLY_WAGE}.`
      : undefined

  const minError =
    payValue < min_wage ? `Min Hourly Wage is $${min_wage}.` : undefined

  const noValueError =
    payValue === undefined || payValue === null || payValue === 0
      ? 'Please enter a valid pay rate.'
      : undefined

  return maxError || minError || noValueError
}
